"use client";
import StyledComponentsRegistry from "@/utils/lib/AntdRegistry";

import contact_icon from "@/assets/images/contact_icon.svg";
import contact_icon_active from "@/assets/images/contact_icon_active.svg";
import scanCode from "@/assets/images/scanCode.png";
import { onlineContactUrl, registerUrl } from "@/constants/api";
import { FloatButton } from "antd";

import tel_icon from "@/assets/images/tel_icon.svg";
import tel_icon_active from "@/assets/images/tel_icon_active.svg";

import code_icon from "@/assets/images/code_icon.svg";
import code_icon_acive from "@/assets/images/code_icon_active.svg";

import styles from "./index.module.scss";

import toRegist from "@/assets/images/toRegist.svg";
import toRegist_active from "@/assets/images/toRegist_active.svg";

import top_icon from "@/assets/images/top_icon.svg";
import top_icon_active from "@/assets/images/top_icon_active.svg";

export default function FixFooter() {
  function goRegister() {
    window.open(registerUrl, "_blank");
  }
  function goContact() {
    window.open(onlineContactUrl, "_blank");
  }
  return (
    <StyledComponentsRegistry>
      <div className={styles.fixFooter}>
        <ul className={styles.footerList}>
          <li className={styles.item} onClick={goContact}>
            <img src={contact_icon.src} alt="" className={styles.icon} />
            <img
              src={contact_icon_active.src}
              alt=""
              className={styles.iconActive}
            />
          </li>
          <li className={styles.item}>
            <img src={tel_icon.src} alt="" className={styles.icon} />
            <img
              src={tel_icon_active.src}
              alt=""
              className={styles.iconActive}
            />
            <div className={styles.phoneBox}>
              <div className={styles.tit}>客服热线</div>
              <div className={styles.phone}>400-102-2518</div>
              <span></span>
            </div>
          </li>
          <li className={styles.item}>
            <img src={code_icon.src} alt="" className={styles.icon} />
            <img
              src={code_icon_acive.src}
              alt=""
              className={styles.iconActive}
            />
            <div className={styles.scanCodeModal}>
              <img src={scanCode.src} />
              <div className={styles.tit}>关注360织语官方微信</div>
              <span></span>
            </div>
          </li>
          <li className={styles.item} onClick={goRegister}>
            <img src={toRegist.src} alt="" className={styles.icon} />
            <img
              src={toRegist_active.src}
              alt=""
              className={styles.iconActive}
            />
          </li>
          <li className={styles.item}>
            <FloatButton.BackTop
              visibilityHeight={0}
              className={styles.scrollTop}
            ></FloatButton.BackTop>
            <img src={top_icon.src} alt="" className={styles.icon} />
            <img
              src={top_icon_active.src}
              alt=""
              className={styles.iconActive}
            />
          </li>
        </ul>
      </div>
    </StyledComponentsRegistry>
  );
}
